/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 15:26:57
 * @LastEditTime: 2019-09-02 17:59:53
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import qs from 'qs';
import route from '@/router.js'
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器
// axios.defaults.baseURL = process.env.VUE_APP_URL
// axios.defaults.baseURL = process.env.VUE_APP_URL    
var apis={
};
if(process.env.VUE_APP_type== 'development'){
    apis={
        login:'http://login.c.smartcode.vip/api/v1',
        logistics:'http://dealer.c.smartcode.vip/api/v1',
        logistics_1:'http://dealer.c.smartcode.vip/dealer/v1',
        logistics_2:'http://pps.c.smartcode.vip/index.php/',
        oem:'https://dealer.c.smartcode.vip/pay/v1',
        dealer_pc:'http://dealer.c.smartcode.vip/index.php/',
        local:"http://jxspps.com/index.php",
        conf:'http://logistics.c.smartcode.vip/admin/v2'
    }
}else if(process.env.VUE_APP_type== 'person'){
        apis={
            login:'http://login.tx315.vip/api/v1',
            logistics:"http://dealer.tx315.vip/api/v1",
            logistics_1:'http://dealer.tx315.vip/dealer/v1',
            logistics_2:'https://pps.tx315.vip/index.php/',
            conf:'http://logistics.tx315.vip/admin/v2',
            oem:'https://dealer.tx315.vip/pay/v1',
            webUrl:'http://jifen.tx315.vip/',
            dealer_pc:'http://yxfk.qiema.cn//index.php/'
        }
}else if(process.env.VUE_APP_type== 'zd'){
    apis={
        login:'http://login.cn2de.com/api/v1',
        logistics:"http://dealer.cn2de.com/api/v1",
        logistics_1:'http://dealer.cn2de.com/dealer/v1',
        logistics_2:'https://zs.cn2de.com/index.php/',
        conf:'http://logistics.cn2de.com/admin/v2',
        oem:'https://dealer.cn2de.com/pay/v1',
         webUrl:'http://jifen.cn2de.com/'
    }
}else if(process.env.VUE_APP_type== 'ym'){
    apis={
        login:'https://login.ymbiaoshi.com/api/v1',
        logistics:"https://dealer.ymsaas.com/api/v1",
        logistics_1:'https://dealer.ymsaas.com/dealer/v1',
        logistics_2:'https://pps.ymsaas.com/index.php/',
        conf:'https://logistics.ymsaas.com/admin/v2',
        oem:'httpss://dealer.ymsaas.com/pay/v1',
        webUrl:'https://jifen.ymsaas.com/',
        dealer_pc:'https://yxfk.qiema.cn//index.php/'
    }
}else if(process.env.VUE_APP_type== 'kjifen'){
    apis={
        login:'https://login.keleshuma.com/api/v1',
        logistics:"https://dealer.keleshuma.com/api/v1",
        logistics_1:'https://dealer.keleshuma.com/dealer/v1',
        logistics_2:'https://pps.keleshuma.com/index.php/',
        conf:'https://login.keleshuma.com/admin/v2',
        oem:'https://dealer.keleshuma.com/pay/v1',
        webUrl:'https://jifen.keleshuma.com/',
        dealer_pc:'https://kyxfk.qiema.vip/index.php/'
    }
}else if(process.env.VUE_APP_type== 'ncbu'){
    apis={
        login:'https://login.ncbu.cn/api/v1',
        logistics:"https://dealer.ncbu.cn/api/v1",
        logistics_1:'https://dealer.ncbu.cn/dealer/v1',
        logistics_2:'https://pps.ncbu.cn/index.php/',
        conf:'https://logistics.ncbu.cn/admin/v2',
        oem:'https://dealer.ncbu.cn/pay/v1',
        webUrl:'https://jifen.ncbu.cn/',
        dealer_pc:'http://yxfk.qiema.cn//index.php/'
    }
}else if(process.env.VUE_APP_type== 'dy'){
    apis={
        login:'https://login.dayanga.net/api/v1',
        logistics:"https://dealer.dayanga.net/api/v1",
        logistics_1:'https://dealer.dayanga.net/dealer/v1',
        logistics_2:'https://pps.dayanga.net/index.php/',
        conf:'https://logistics.dayanga.net/admin/v2',
        oem:'https://dealer.dayanga.net/pay/v1',
        webUrl:'https://jifen.dayanga.net/',
        dealer_pc:'http://yxfk.dayanga.net/index.php/'
    }
}else if(process.env.VUE_APP_type== 'qs'){
    apis={
        login:'https://login.qsfw.net/api/v1',
        logistics:"https://dealer.qsfw.net/api/v1",
        logistics_1:'https://dealer.qsfw.net/dealer/v1',
        logistics_2:'https://pps.qsfw.net/index.php/',
        conf:'https://logistics.qsfw.net/admin/v2',
        oem:'https://dealer.qsfw.net/pay/v1',
        webUrl:'https://jifen.qsfw.net/',
        dealer_pc:'http://yxfk.qsfw.net/index.php/'
    }
}else if(process.env.VUE_APP_type== 'kmd'){
    apis={
        login:'https://login.s106.xcx008.com/api/v1',
        logistics:"https://dealer.s106.xcx008.com/api/v1",
        logistics_1:'https://dealer.s106.xcx008.com/dealer/v1',
        logistics_2:'https://pps.s106.xcx008.com/index.php/',
        conf:'https://logistics.s106.xcx008.com/admin/v2',
        oem:'https://dealer.s106.xcx008.com/pay/v1',
        webUrl:'https://jifen.s106.xcx008.com/',
        dealer_pc:'http://yxfk.s106.xcx008.com/index.php/'
    }
}else if(process.env.VUE_APP_type== 'xc'){
    apis={
        login:'https://login.cnxcyx.com/api/v1',
        logistics:"https://dealer.cnxcyx.com/api/v1",
        logistics_1:'https://dealer.cnxcyx.com/dealer/v1',
        logistics_2:'https://pps.cnxcyx.com/index.php/',
        conf:'https://logistics.cnxcyx.com/admin/v2',
        oem:'https://dealer.cnxcyx.com/pay/v1',
        webUrl:'https://jifen.cnxcyx.com/',
        dealer_pc:'http://dealer.cnxcyx.com/index.php/'
    }
}else if(process.env.VUE_APP_type== 'ry'){
    apis={
        login:'https://login.fwmcx.com/api/v1',
        logistics:"https://dealer.fwmcx.com/api/v1",
        logistics_1:'https://dealer.fwmcx.com/dealer/v1',
        logistics_2:'https://pps.fwmcx.com/index.php/',
        conf:'https://logistics.fwmcx.com/admin/v2',
        oem:'https://dealer.fwmcx.com/pay/v1',
        webUrl:'https://jifen.fwmcx.com/',
        dealer_pc:'http://dealer.fwmcx.com/index.php/'
    }
}else if(process.env.VUE_APP_type== 'bcx'){
    apis={
        login:'https://login.baochengxin.com/api/v1',
        logistics:"https://dealer.baochengxin.com/api/v1",
        logistics_1:'https://dealer.baochengxin.com/dealer/v1',
        logistics_2:'https://pps.baochengxin.com/index.php/',
        conf:'https://logistics.baochengxin.com/admin/v2',
        oem:'https://dealer.baochengxin.com/pay/v1',
        webUrl:'https://jifen.baochengxin.com/',
        dealer_pc:'http://dealer.baochengxin.com/index.php/'
    }
}else if(process.env.VUE_APP_type== 'tkkj'){
    apis={
        login:'https://login.tksmys.com/api/v1',
        logistics:"https://dealer.tksmys.com/api/v1",
        logistics_1:'https://dealer.tksmys.com/dealer/v1',
        logistics_2:'https://pps.tksmys.com/index.php/',
        conf:'https://logistics.tksmys.com/admin/v2',
        oem:'https://dealer.tksmys.com/pay/v1',
        webUrl:'https://jifen.tksmys.com/',
        dealer_pc:'http://dealer.tksmys.com/index.php/'
    }
}else{
    apis={
        login:'http://login.smartcode.vip/api/v1',
        logistics:"http://dealer.smartcode.vip/api/v1",
        logistics_1:'http://dealer.smartcode.vip/dealer/v1',
        logistics_2:'https://pps.smartcode.vip/index.php/',
        conf:'http://logistics.smartcode.vip/admin/v2',
        oem:'https://dealer.smartcode.vip/pay/v1',
        webUrl:'http://jifen.smartcode.vip/',
        dealer_pc:'http://yxfk.qiema.cn//index.php/'
    }
}

export default apis
// apis={
//     login:'http://login.c.smartcode.vip/api/v1',
//     logistics:'http://dealer.c.smartcode.vip/api/v1',
//     logistics_1:'http://dealer.c.smartcode.vip/dealer/v1',
//     logistics_2:'http://pps.c.smartcode.vip/index.php/',
//     oem:'https://dealer.c.smartcode.vip/pay/v1',
//     dealer_pc:'http://dealer.c.smartcode.vip/index.php/',
//     local:"http://jxspps.com/index.php",
//     conf:'http://logistics.c.smartcode.vip/admin/v2'
// }
axios.interceptors.request.use(
    config => {
        config.data = qs.stringify(config.data);
        config.headers = {
            'Content-Type':'application/x-www-form-urlencoded',
            'accept':'application/json',
        }
            if(localStorage.getItem('access_token')){
            config.headers.Authorization ='Bearer' + " " +localStorage.getItem('access_token');
            }

        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        if(response.data.code ==100){
            location.href = location.href.split('#/')[0] + '#/login';//跳回登陆页面
        }
        return response;
    },
    error => {
        if(error.response.data){
            return Promise.reject(error.response.data)

        }
    }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(module,url,params={}){
    var baseUrl=''
 
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }
    else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }
    else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    
    else
    {
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {

        axios.get(baseUrl,{
            params:params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module,url,data = {}){

    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }  else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.post(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module,url,data = {}){
    
    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.patch(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module,url,data = {}){
    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.put(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module,url,data = {}){
    var baseUrl=''
    if(module==='login'){
        baseUrl=apis.login+url
    }else if(module=='logistics'){
        baseUrl=apis.logistics+url
        
    }else if(module=='logistics_1'){
        baseUrl=apis.logistics_1+url
    }else if(module=='conf'){
        
        baseUrl=apis.conf+url
    }else if(module=='oem'){
        
        baseUrl=apis.oem+url
    }else if(module=='dealer_pc'){
        
        baseUrl=apis.dealer_pc+url
    }else if(module=='local'){
        
        baseUrl=apis.local+url
    }
    else{
        baseUrl=apis.logistics_2+url
    }
    return new Promise((resolve,reject) => {
        axios.delete(baseUrl,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

